import { render, staticRenderFns } from "./SayfaGuncelle.vue?vue&type=template&id=3245aaae&"
import script from "./SayfaGuncelle.vue?vue&type=script&lang=js&"
export * from "./SayfaGuncelle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports